import ShadowContainerVertical from '@atoms/ShadowContainerVertical/ShadowContainerVertical';
import { ISubMenuItem } from '@models/IHeader';
import { motion } from 'framer-motion';
import MobileSecondLevelContent from './MobileSecondLevelContent';

interface Props {
  readonly activeTab: ISubMenuItem[];
  readonly secondLevelTitle: string;
}

const MobileSecondLevel = ({ activeTab, secondLevelTitle }: Props) => {
  const mobileMenuVariant = {
    opened: {
      x: '100%',
      transition: {
        delay: 0.15,
        duration: 1.1,
        ease: [0.74, 0, 0.19, 1.02],
      },
    },
    closed: {
      x: '200%',
      transition: {
        delay: 0.35,
        duration: 0.63,
        ease: [0.74, 0, 0.19, 1.02],
      },
    },
  };

  return (
    <motion.div
      className="absolute bottom-0 left-0 right-0 top-0 overflow-y-auto"
      initial="closed"
      variants={mobileMenuVariant}
      data-testid="CT-01-Header-Mobile-Second-Level"
    >
      <ShadowContainerVertical shadowColour="from-white" shadowHeight="h-6">
        <p
          className="h5 pb-3 pl-5  pr-5 text-black-100 md:pl-8 md:pr-8 lgm:pl-32"
          data-testid={`CT-01-Header-Mobile-Second-Level-Title-${secondLevelTitle}`}
        >
          {secondLevelTitle}
        </p>
        <MobileSecondLevelContent
          activeTab={activeTab}
          mainCategory={secondLevelTitle}
        />
      </ShadowContainerVertical>
    </motion.div>
  );
};

export default MobileSecondLevel;
